import request from '@/utils/request'
import { addQueryToUrl } from '@/utils/utils'

const baseUrl = process.env.VUE_APP_PURCHASE_API

// ------------------------------ 规则库 --------------------------------

// 获取风险规则code
export function getRiskRulesCodesApi() {
  return request({
    url: baseUrl + '/risks/v2/rules/codes',
    method: 'get'
  })
}

// 风险类型
export function getRiskRulebaseRouteTreeApi(params) {
  return request({
    url: baseUrl + '/risks/v2/rules/catalogs',
    method: 'get',
    params
  })
}

// 分页查询规则库
export function getRiskRulebaseListApi(params) {
  return request({
    url: baseUrl + '/risks/v2/rules/page',
    method: 'get',
    params
  })
}

// 查询公司规则路由
export function getRiskRulebaseDetailApi(ruleId) {
  return request({
    url: baseUrl + `/risks/v2/rules/${ruleId}/detail`,
    method: 'get'
  })
}

// 公司路由规则编辑更新
export function updateRiskRulebaseApi(data) {
  const { ruleId, ...other } = data
  return request({
    url: baseUrl + `/risks/v2/rules/${ruleId}`,
    method: 'put',
    data: other
  })
}

// ------------------------------ 风险记录与处理 --------------------------------

// 分页查询风险监控日志
export function getRiskHandleListApi(params) {
  return request({
    url: baseUrl + '/monitor/risk/order-monitor/page',
    method: 'get',
    params
  })
}

// 分页查询风险监控日志-新
export function newGetRiskHandleListApi(params) {
  return request({
    url: baseUrl + '/risks/v2/page',
    method: 'get',
    params
  })
}

// 导出
export function exportRiskHandleApi(params) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/monitor/risk/order-monitor/riskOrder/export`,
      params
    ),
    '_blank'
  )
}

// 导出-新
export function newExportRiskHandleApi(params) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/risks/v2/report`,
      params
    ),
    '_blank'
  )
}

// 风险监控详情
export function getRiskHandleDetailApi(orderMonitorId) {
  return request({
    url: baseUrl + `/monitor/risk/order-monitor/${orderMonitorId}`,
    method: 'get'
  })
}

// 风险监控详情-新
export function newGetRiskHandleDetailApi(riskId) {
  return request({
    url: baseUrl + `/risks/v2/${riskId}/detail`,
    method: 'get'
  })
}

// 风险监控处理
export function setRiskHandleApi(data) {
  const { orderMonitorId, ...other } = data
  return request({
    url: baseUrl + `/monitor/risk/order-monitor/${orderMonitorId}`,
    method: 'post',
    data: other
  })
}

// 风险监控处理-新
export function newSetRiskHandleApi(data) {
  const { riskId, ...other } = data
  return request({
    url: baseUrl + `/risks/v2/${riskId}/handle`,
    method: 'post',
    data: other
  })
}

// 风险已读
export function setRiskReadApi(orderMonitorId) {
  return request({
    url: baseUrl + `/monitor/risk/order-monitor/${orderMonitorId}/read`,
    method: 'put'
  })
}

// 企业查看风险列表
export function setRiskReadListApi(orderMonitorId) {
  return request({
    url: baseUrl + `/monitor/risk/order-monitor/${orderMonitorId}/read`,
    method: 'get'
  })
}

// ------------------------------ 风险报表 --------------------------------

// 采购单位风险报表
export function getRiskReportListApi(params) {
  return request({
    url: baseUrl + '/risks/v2/statistics/purchaser/report/page',
    method: 'get',
    params
  })
}

// 导出
export function exportRiskReportApi(params) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/risks/v2/statistics/purchaser/report/export`,
      params
    ),
    '_blank'
  )
}
